import React, { useState } from 'react';
import PropTypes from 'prop-types';

const StepCard = ({ number, title, description }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      className="step-card"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        boxShadow: hovered ? '0 8px 24px rgba(0,0,0,0.13)' : undefined,
        transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
        transition: 'box-shadow 0.2s ease, transform 0.2s ease',
      }}
    >
      <style>{`
        .step-card {
          position: relative;
          background: #fff;
          border: 1px solid #e0e0e0;
          border-top: 5px solid #f5a623;
          border-radius: 15px;
          padding: 30px 24px 24px;
          text-align: center;
          box-shadow: 0 4px 8px rgba(0,0,0,0.06);
          margin-top: 30px;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        .step-counter {
          position: absolute;
          top: -30px;
          left: 50%;
          transform: translateX(-50%);
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: #f5a623;
          color: #000;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          font-weight: 600;
        }
        .step-card h3 {
          width: 100%;
          font-size: 20px;
          margin: 0 0 6px;
          color: #111;
          font-weight: 600;
          line-height: 1.3;
          text-align: center;
        }
        .step-card p {
          width: 100%;
          font-size: 15px;
          margin: 0;
          color: #383c42;
          font-weight: 400;
          line-height: 1.5;
          text-align: center;
        }
        @media (max-width: 420px) {
          .step-card {
            padding: 50px 20px 28px;
            margin-top: 12px;
          }
          .step-counter {
            width: 65px;
            height: 65px;
            top: -35px;
            font-size: 36px;
          }
          .step-card h3 {
            font-size: 18px;
          }
          .step-card p {
            font-size: 14px;
          }
        }
      `}</style>
      <div className="step-counter">{number}</div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

StepCard.propTypes = {
  number: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default StepCard;
